import * as  React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as _ from 'lodash';
import { formatJsonForWakeWordModel } from '../../../../../services/mini/formatJsonForWakeWordModel';
import { cleanupWakeWordOptions } from '../../../../../services/mini/cleanupWakeWordOptions';
import { IWakeWord } from '../../../../../models/IWakeWord';

type WakeWordPreviewProps = WakeWordPreviewReduxProps & {
    wakeWord: IWakeWord
}

function WakeWordPreview({ wakeWord }: WakeWordPreviewProps) {

    let wakeWordOptions = null;
    let modelJson = null;
    let acousticName = 'Unknown';

    try {
        wakeWordOptions = JSON.parse(wakeWord.options);
        acousticName = wakeWordOptions.acoustic_name;
        modelJson = formatJsonForWakeWordModel(JSON.stringify(cleanupWakeWordOptions(wakeWordOptions)));
    } catch {

    }

    return <div className="wakeword-preview">
        {wakeWordOptions ?
            <React.Fragment>
                {acousticName && <div>
                    <label className="wakeword-preview__label">Acoustic model:</label> <b>{acousticName}</b>
                </div>}
                {modelJson && <div>
                    <pre>
                        {modelJson}
                    </pre>
                </div>}
            </React.Fragment> :
            <div>Unable to display wake word preview</div>}
    </div>;
}


function mapStateToProps({ config }) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type WakeWordPreviewReduxProps = ConnectedProps<typeof connector>;

export default connector(WakeWordPreview);